var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.66 96C169.72 96 85.7523 146.373 21.7081 238.176C14.3137 248.891 14.1006 262.916 21.1214 273.783C76.6196 360.657 162.152 416 255.66 416C348.576 416 435.648 359.939 490.935 273.361C497.723 262.815 497.723 249.215 490.905 238.621C464.696 198.142 430.406 163.144 391.577 138.073C349.372 110.823 303.058 96 255.66 96ZM255.66 128C335.729 128 413.794 178.404 464.019 255.976C464.025 255.985 464.025 256.045 463.996 256.091C414.165 334.123 336.698 384 255.66 384C174.878 384 99.6278 335.833 49.5531 258.829L47.999 256.417C106.366 172.753 180.965 128 255.66 128ZM256 160C202.981 160 160 202.981 160 256C160 309.019 202.981 352 256 352C309.019 352 352 309.019 352 256C352 202.981 309.019 160 256 160ZM256 192C291.346 192 320 220.654 320 256C320 291.346 291.346 320 256 320C220.654 320 192 291.346 192 256C192 220.654 220.654 192 256 192Z",
    fill: "#222428"
  })));
};

export { SvgView as ReactComponent };
export default __webpack_public_path__ + "static/media/images/view.svg";